import {
  makeIsTopRatedEmpty,
  makeTopRatedDataByKey,
} from '../../../../redux/selectors/topRatedSelector';
import { useSelector } from '../../../../redux/utils';

export const useData = () => {
  const isFetching = useSelector(makeTopRatedDataByKey('isFetching'));
  const isTopRatedEmpty = useSelector(makeIsTopRatedEmpty());

  return {
    isTopRatedEmpty,
    isFetching,
  };
};
